import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Globals} from '../../global/globals';
import {GlobalSearchResultGroup, GlobalSearchResults} from '../../dtos/search/global-search-results';
import {SearchResultType} from '../../shared/search/search-result-type';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {

  private searchUri: string = this.globals.backendUri + '/search';

  constructor(private httpClient: HttpClient, private globals: Globals) {
  }

  search(query: string, limit: number = 5): Observable<GlobalSearchResults> {
    const params = new HttpParams().set('q', query).set('limit', String(limit));
    return this.httpClient.get<GlobalSearchResults>(this.searchUri, {params});
  }

  searchType(query: string, type: SearchResultType, limit: number): Observable<GlobalSearchResultGroup> {
    const params = new HttpParams().set('q', query).set('limit', String(limit));
    return this.httpClient.get<GlobalSearchResultGroup>(`${this.searchUri}/${type}`, {params});
  }
}
